import CustomerTradeWasteDeed from "./modals/customer-trade-waste-deed";

export default CustomerTradeWasteDeed;